import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Home from "./components/Home";
import ResumeEditor from "./components/ResumeEditor";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <title>CurrículoPRO - Crie seu currículo profissional grátis</title>
          <meta name="description" content="Crie seu currículo profissional em minutos, sem cadastro e sem internet. Gere PDFs prontos para enviar direto do seu celular ou computador." />
          <meta name="google-adsense-account" content="ca-pub-8865950968566432" />
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
          <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
        </Helmet>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/editor" element={<ResumeEditor />} />
            <Route path="/privacidade" element={<PrivacyPolicy />} />
            <Route path="/termos" element={<TermsOfUse />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
